import { createContext } from 'react'
import { ImportContextUtils } from 'pages/orchestration/workflows/edit/components/sidebarConfigs/forms/activity/ImportContext/interfaces'

export const ImportContextData = createContext({} as ImportContextUtils)
